import {LanguageDropDown} from "../src/js/lib/language_dropdown";

require("@rails/ujs").start();
require("turbolinks").start();
require("../src/scss/membership.scss");
require("../src/scss/slick.scss");

require("../src/js/lib/join/google_ecommerce");
require("../src/js/lib/join/responsive_page");
require("../src/js/lib/game/slick.js");
require("../src/js/lib/join/responsive_skus");
require("../src/js/lib/language_dropdown");
require("../src/js/lib/game/pop_external_link_warning");



import $ from 'jquery';


const jQueryProp = {
    value: $,
    configurable: false,
    writable: false
}

Object.defineProperties(window, { jQuery: jQueryProp, $: jQueryProp })
import 'jquery.cookie';

require("../src/js/lib/remodal.js");

import { GoogleEcommerce } from '../src/js/lib/join/google_ecommerce';
import { ResponsivePage } from '../src/js/lib/join/responsive_page';
import { PopExternalLinkWarning } from '../src/js/lib/game/pop_external_link_warning';
import {EnableFlash} from "../src/js/lib/game/enable_flash";

function setupLanguageDropDown() {
    LanguageDropDown.setup('.language-dropdown');
}

function setupGoogleEcommerce() {
    GoogleEcommerce.setup();
}

function setupResponsivePage() {
    ResponsivePage.setup();
}

function setupExternalLinkPopUp() {
    PopExternalLinkWarning.setup();
}

function setupEnableFlash() {
    EnableFlash.setup();
}

function setScrollForGiftCertificatesTag() {
    $(".gift-cert-tag").click(function (){
        $('html, body').animate({
            scrollTop: $("#membership-gift-certificates").offset().top
        },0);
    });
}

$(document).ready(function($){
    setupGoogleEcommerce();
    setupResponsivePage();
    setupLanguageDropDown();
    setScrollForGiftCertificatesTag();
    setupExternalLinkPopUp();
  //  setupEnableFlash();
});


